<div class="page-content-wrapper">
  <div v-if="loading" class="text-center mt-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div v-else>
    <div class="row mt-0">
      <div class="col-md-12">
        <div class="card rounded-3 border-1 shadow">
          <div class="card-header bg-white border-0">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <h5 class="mb-1 fw-bold text-dark">Workflow Services</h5>
                <p class="mb-0 text-muted small">{{ project_name }} project</p>
              </div>
              <div class="d-flex gap-2">
                <button type="button" class="btn bg-green btn-sm rounded-small shadow fw-bold text-xxs" @click="show_customize_register_modal">
                  <i class="fas fa-cog me-1"></i>Customize Register
                </button>
                <button type="button" class="btn btn-dark btn-sm rounded-small shadow fw-bold text-xxs" @click="navigate_to_client_service">
                  <i class="fas fa-plus me-1"></i>Add Services
                </button>
              </div>
            </div>
          </div>

          <div class="card-body">
              <table id="workflow-service-table" class="table-responsive w-100">
                <thead class="bg-dark text-white">
                  <tr>
                    <th class="bg-dark text-center text-uppercase text-xxs font-weight-bolder opacity-7">ID</th>
                    <th class="bg-dark text-uppercase text-xxs font-weight-bolder opacity-7">Service Name</th>
                    <th class="bg-dark text-uppercase text-xxs font-weight-bolder opacity-7">Check</th>
                    <th class="bg-dark text-uppercase text-xxs font-weight-bolder opacity-7">Rules</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(service, index) in services" :key="service.service_id">
                    <td class="text-center text-xxs">{{ index + 1 }}</td>
                    <td class="text-xxs">{{ service.service_name }}</td>
                    <td class="text-xxs">
                        <div class="custom-control custom-checkbox">
                            <input 
                                class="form-check-input checkbox-shadow"
                                type="checkbox" 
                                :id="'check' + index" 
                                :name="'check' + index"
                                v-model="service.is_checked"
                                @change="handle_service_check(service.id, $event.target.checked)"
                            >
                            <label :for="'check' + index" class="custom-control-label"></label>
                        </div>
                    </td>
                    <td class="text-xxs">
                        <div class="d-flex align-items-center flex-wrap">
                            <div v-if="service.service_type != 'system generated' && SERVICES_WITH_RULES.includes(service.service_name)">
                                <button class="btn btn-dark rounded-small text-white fw-bold btn-sm text-xxs shadow"
                                        @click="route_to_rules(service.service_id)"
                                        :class="{ 'disabled-button': !service.is_checked }"
                                        :disabled="!service.is_checked">
                                    <i class="fas fa-cog me-1"></i>Set Rule
                                </button>
                            </div>
                            <div class="form-check form-switch ms-2" v-if="SAFPS_SERVICES.includes(service.service_name)">
                                <input class="form-check-input" 
                                      type="checkbox" 
                                      :id="'safps_' + service.id"
                                      :checked="safps_checks[service.id] || false"
                                      :disabled="!service.is_checked"
                                      @change="handle_safps_check(service.id, $event.target.checked)"/>
                                <label class="form-check-label text-xxs" :for="'safps_' + service.id">
                                    SAFPS Check
                                </label>
                            </div>
                            <div class="form-check form-switch ms-2" v-if="DECISION_ENGINE_SERVICES.includes(service.service_name)">
                                <input class="form-check-input" 
                                      type="checkbox" 
                                      :id="'decision_engine_' + service.id"
                                      :checked="add_decision_engine[service.id] || false"
                                      :disabled="!service.is_checked"
                                      @change="handle_decision_engine_check(service.id, $event.target.checked)"/>
                                <label class="form-check-label text-xxs" :for="'decision_engine_' + service.id">
                                    Decision Engine
                                </label>
                            </div>
                        </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            <div class="d-flex justify-content-end mt-0">
              <button type="button" class="btn bg-green rounded-small text-xxs fw-bold shadow" @click="route_to_arrange_workflow">Next</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

